import React from 'react';

import Quicks from '../components/quicks';
import Gallery from '../components/gallery';

const Component = () => {
    return (
        <div>
            <Quicks external links={[]} navs={[]} />

            <Gallery />
        </div>
    );
};

export default Component;
